import { cn } from "@/lib/utils";

export function HtmlTableCell({
  html,
  expanded = false,
}: {
  html: string;
  expanded?: boolean;
}) {
  const trimmed = html.trim();
  if (!trimmed) return null;
  return (
    <div
      className={cn(
        "html-view min-w-0 text-sm leading-snug",
        expanded
          ? "py-0.5 [&_img]:max-h-24 [&_img]:max-w-full [&_p]:my-0.5"
          : "line-clamp-1 overflow-hidden py-0 [&_*]:inline [&_br]:hidden [&_img]:hidden [&_p]:my-0 [&_p]:inline",
      )}
      dangerouslySetInnerHTML={{ __html: trimmed }}
    />
  );
}
